import React from "react";
import { TablePagination } from "@material-ui/core";

function TablePaginationCustom({ count, pagination, onChangePagination }) {

  const handleChangePage = (e, page) => {
    onChangePagination({ ...pagination, pagina: page });
  };

  const handleChangeRowsPerPage = (e) => {    
    onChangePagination({ ...pagination, pagina: 0, itensPorPagina: parseInt(e.target.value, 10) });
  };

  return (
    <TablePagination
      rowsPerPageOptions={[20, 50, 100]}
      component="div"
      count={count}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      rowsPerPage={pagination.itensPorPagina}
      labelRowsPerPage={"Registros por página"}
      labelDisplayedRows={(page) =>
        `${page.from} - ${page.to} de ${page.count}`
      }
      page={pagination.pagina}
    />
  );
}

export default TablePaginationCustom;
